var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPanelWhite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_159875",
    "data-name": "Group 159875",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.439,
    height: 36.913,
    viewBox: "0 0 30.439 36.913",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147480",
    "data-name": "Rectangle 147480",
    width: 30.439,
    height: 36.913,
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_159874",
    "data-name": "Group 159874",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147476",
    "data-name": "Rectangle 147476",
    width: 30.021,
    height: 36.495,
    rx: 3,
    transform: "translate(0.209 0.209)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147477",
    "data-name": "Rectangle 147477",
    width: 24.076,
    height: 30.634,
    rx: 2.021,
    transform: "translate(3.129 3.129)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37516",
    "data-name": "Path 37516",
    d: "M155.22,76.839a2.592,2.592,0,1,1-2.592-2.592A2.592,2.592,0,0,1,155.22,76.839Z",
    transform: "translate(-137.472 -68.029)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37517",
    "data-name": "Path 37517",
    d: "M89.472,165.077a2.592,2.592,0,1,1-2.592-2.592A2.592,2.592,0,0,1,89.472,165.077Z",
    transform: "translate(-77.23 -148.878)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37518",
    "data-name": "Path 37518",
    d: "M221.675,165.077a2.592,2.592,0,1,1-2.592-2.592A2.592,2.592,0,0,1,221.675,165.077Z",
    transform: "translate(-198.362 -148.878)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_200",
    "data-name": "Line 200",
    x2: 16.254,
    transform: "translate(7.059 24.793)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_201",
    "data-name": "Line 201",
    x2: 16.254,
    transform: "translate(7.059 27.247)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_202",
    "data-name": "Line 202",
    x2: 16.254,
    transform: "translate(7.059 29.701)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37519",
    "data-name": "Path 37519",
    d: "M26.854,88.608h-.867a.5.5,0,0,1-.5-.5v-4.02a.5.5,0,0,1,.5-.5h.867a.5.5,0,0,1,.5.5v4.02a.5.5,0,0,1-.5.5",
    transform: "translate(-23.354 -76.594)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147478",
    "data-name": "Rectangle 147478",
    width: 1.862,
    height: 5.014,
    rx: 0.931,
    transform: "translate(2.135 7)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37520",
    "data-name": "Path 37520",
    d: "M26.854,302.542h-.867a.5.5,0,0,1-.5-.5v-4.02a.5.5,0,0,1,.5-.5h.867a.5.5,0,0,1,.5.5v4.02a.5.5,0,0,1-.5.5",
    transform: "translate(-23.354 -272.612)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_147479",
    "data-name": "Rectangle 147479",
    width: 1.862,
    height: 5.014,
    rx: 0.931,
    transform: "translate(2.135 24.916)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelWhite);
export default __webpack_public_path__ + "static/media/Panel-White.181122159408de3811433fd03288b74d.svg";
export { ForwardRef as ReactComponent };